export default __webpack_public_path__ + "static/metrasense-8b54f197413ec054f63f83640733830f.svg";